<!-- Card -->
<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'general.general' | translate }}
    </h3>
  </div>
  <!-- End Header -->

  <!-- Body -->
  <div class="card-body">
    <organization-form
      (onSubmit)="onSubmit($event)"
      [organization]="organization$ | async"
      [disableSaveButton$]="disableSaveButton$.asObservable()"
    >
    </organization-form>
  </div>
  <!-- End Body -->
</section>
<!-- End Card -->
